import React from 'react';
import { useParams, Redirect } from 'react-router';

const WelcomePageRedirect = () => {
  const { userId, updateToken } = useParams<{userId: string, updateToken: string}>();
  return <Redirect to={`/welcome/first-login/${userId}/${updateToken}`} />;
};

export default WelcomePageRedirect;
